import * as React from 'react';

import { Ellipsis } from '@common/components/Ellipsis';
import { LOOKUP_MODULE_NAME } from '../../LookupTable';

import './Text.styles.scss';

export const Text = (props) => {
  const { value, defaultValue, id, index } = props;

  return (
    <Ellipsis id={`${LOOKUP_MODULE_NAME}-text--id-${id}--index-${index}`} text={value || defaultValue} />
  );
};